import PropTypes from 'prop-types';
import React from 'react';
import {FormGroup} from 'react-bootstrap';

/**
 * A FormGroup component that displays an error message if its `isValid` prop is false.
 *
 * It also supports the `label` and `errorLabel` properties
 * @type {any}
 */
class ValidatorFormGroup extends React.Component {
    render() {
        const className = `${this.props.hideErrorLabel ? '' : 'error'} ${this.props.className}`;
        return (
            <FormGroup
                className={className}
            >
                <label htmlFor="">{this.props.label}</label>
                <div className="form-line">{this.props.children}</div>
                {this.props.helpLabel ? (
                    <div className="alert alert-info">
                        {this.props.helpLabel}
                    </div>
                ) : (
                    ''
                )}
                {this.props.hideErrorLabel ? (
                    ''
                ) : (
                    <div className="alert alert-danger">
                        {this.props.errorLabel}
                    </div>
                )}
            </FormGroup>
        );
    }
}

ValidatorFormGroup.defaultProps = {
    hideErrorLabel: true,
    label: 'label',
    helpLabel: '',
    errorLabel: '',
    className: ''
};

ValidatorFormGroup.propTypes = {
    hideErrorLabel: PropTypes.bool.isRequired,
    label: PropTypes.element.isRequired,
    helpLabel: PropTypes.string,
    errorLabel: PropTypes.string.isRequired,
    className: PropTypes.string
};

export default ValidatorFormGroup;
